import * as React from "react";
const SvgSoftware = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 2.813v18.375H22.13V2.811H12ZM3.38 4.31H20.62v2.246H3.38V5.434Zm0 3.753H20.62V19.69H3.38v-5.812zm4.465 2.467c-.003 0-.242.237-.532.526-.289.289-.525.53-.525.535 0 .005.513.52 1.139 1.146l1.136 1.139-1.14 1.14-1.139 1.14.53.53.53.53 1.673-1.672 1.673-1.674-1.671-1.67c-.92-.919-1.672-1.67-1.674-1.67Zm5.097 3.533V15.561h3.745V14.064h-1.873Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSoftware;
